import flyttPkbActions from "./flyttPkbActions";

export default flyttPkbActions;
